import React, { Component } from 'react';
import { Table, Column, Cell, ActionCell } from 'components/Table';

import Score from 'components/Score';
import ReactTooltip from 'react-tooltip';

import 'components/PupsquestMetricsPanel/pupsquestMetricsPanel.scss';

import { soundFarm, traceRace, reallyWriting, soundBlend, reallyReading, wordBuilder} from '../../util/metrics';


export class LessonCell extends Component{
    render (){
        return (
            <Cell
                className="narrow">{this.props.item.name}</Cell>
        );
    }
}

export class SoundFarmCell extends Component{
    render (){
        let sf = soundFarm(this.props.item);
        return (
            <Cell className="score-cell align-center">
                <Score
                    value={sf.two.percent}
                    text={sf.two.text}
                    boxClass="metrics-box-color"
                    scoreClass='score-2'
                />
            </Cell>
        );
    }
}

export class TraceRaceCell extends Component{
    render (){
        let tr = traceRace(this.props.item);
        return (
            <Cell className="score-cell align-center">
                <Score
                    value={tr.one.percent}
                    text={tr.one.text}
                    boxClass="metrics-box-color"
                    scoreClass='score-1 single-digit'
                />
                <span className="score-spacer" />
                <Score
                    value={tr.two.percent}
                    text={tr.two.text}
                    boxClass="metrics-box-color"
                    scoreClass='score-2 single-digit'
                />
            </Cell>
        );
    }
}

export class SoundBlendCell extends Component{
    render (){
        let sb = soundBlend(this.props.item);
        return (
            <Cell className="score-cell align-center">
                <Score
                    value={sb.one.percent}
                    text={sb.one.text}
                    boxClass="metrics-box-color"
                    scoreClass='score-1'
                />
                <span className="score-spacer" />
                <Score
                    value={sb.two.percent}
                    text={sb.two.text}
                    boxClass="metrics-box-color"
                    scoreClass='score-2'
                />
            </Cell>
        );
    }
}

export class WordBuilderCell extends Component{
    render (){
        let wb = wordBuilder(this.props.item);
        return (
            <Cell className="score-cell align-center">
                <Score
                    value={wb.one.percent}
                    text={wb.one.text}
                    boxClass="metrics-box-color"
                    scoreClass='score-1'
                />
            </Cell>
        );
    }
}

export class ReallyWritingCell extends Component{
    render (){
        let rw = reallyWriting(this.props.item);
        return (
            <Cell className="score-cell align-center">
                <Score
                    value={rw.two.percent}
                    divisor={100}
                    text={rw.two.text}
                    boxClass="metrics-box-color"
                    scoreClass='score-2 single-digit'
                />
            </Cell>
        );
    }
}

export class ReallyReadingCell extends Component{
    render (){
        let rr = reallyReading(this.props.item);
        return (
            <Cell className="score-cell align-center">
                <Score
                    value={rr.one.percent}
                    text={rr.one.text}
                    boxClass="metrics-box-color"
                    scoreClass='score-1'
                />
                {this.props.item.reallyreading ?
                    (
                        <span>
                            <span className="score-spacer" />
                            <spam className="button listen-button" onClick={this.props.listenAndGrade.bind(this, this.props.item)}>
                                Listen
                            </spam>
                        </span>
                    ) : (
                        <span className="no-audio-btn">
                            <span className="score-spacer" />
                        </span>
                    )}

            </Cell>
        );
    }
}

export class HeaderCell extends Component{
    render(){
        return(
            <Cell className="align-center">
                <span className='two-line'>
                    {this.props.text}
                    {this.props.text2 && (
                        <span className="line2">{this.props.text2}</span>
                    )}
                </span>
                {this.props.tipId && this.props.tooltip &&
                    <span className='two-line-tip'>
                        <a data-tip="custom-show" data-event='click focus' data-for={this.props.tipId}>
                            <span className='tip'>i</span>
                        </a>
                        {this.props.tooltip}
                    </span>
                }
            </Cell>
        );
    }
}

export class HeaderTooltip extends Component{
    render(){
        return (
            <ReactTooltip
                id={this.props.id}
                multiline={true}
                place='bottom'
                className="tool-tip"
            >
                {this.props.content}
            </ReactTooltip>
        );
    }
}

export class LessonHeaderCell extends Component {
    render() {
        return (
            <div className='list-cell narrow'>
                <span className="data" style={{display:'inline'}}>Lesson</span>
                <span className="tip" onClick={() => this.props.toggleLegend()}>i</span>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./js/components/MetricsList/MetricsListCells.js